import { getGenreReqParamsForNew } from '@intelligence/components/GenreSelectMiddleware/Supports/utils';
import { getMainGenresAndSubGenres } from '@intelligence/components/GenreSelectMiddleware/utils';
import { formatGenreSourcesOptions } from '@intelligence/v3/utils/genre';

import type { IGenreSelectValue } from '@intelligence/components/GenreSelect/types';
import type { IGenreRes, IMainGenre } from '@intelligence/types/common';

export const ROBLOX_GENRE_SOURCE = 'roblox';

export interface IRobloxGenreFilterItem {
  value: string;
  relation: string;
  children: Array<{ value: string }>;
}

export const buildRobloxGenreFilterParam = (
  genreValue?: IGenreSelectValue | null,
  robloxOptions?: IMainGenre[],
): { roblox_genre?: IRobloxGenreFilterItem[] } => {
  if (!genreValue?.genres?.length) {
    return {};
  }

  const formattedOptions = robloxOptions?.length
    ? (formatGenreSourcesOptions({ roblox: robloxOptions } as IGenreRes).roblox || [])
    : [];

  const { mainGenres, subGenres, level3Genres, level4Genres } = getMainGenresAndSubGenres(
    genreValue,
    formattedOptions,
  );

  const { genres } = getGenreReqParamsForNew({
    source: genreValue.source,
    mainGenres,
    subGenres,
    level3Genres,
    level4Genres,
    options: formattedOptions,
  });

  if (!genres?.length) {
    return {};
  }

  return { roblox_genre: genres as IRobloxGenreFilterItem[] };
};
